import React from 'react';
import { WhatsAppButton } from 'components';
import { ApprovedImage } from 'assets/img';
import DocumentIcon from '../../../assets/icons/documents-2.png';

interface Props {
  onClose?: () => void;
  goToValidation?: () => void;
  userName?: string;
}

class ModalWelcome extends React.Component<Props> {
  render() {
    return (
      <div id='modal-welcome'>
        <div className='container-flex'>
          <div className='container-icon'>
            <img src={ApprovedImage} alt='Registro exitoso' />
          </div>
          <div style={{ flex: 1 }}>
            <h4>¡{this.props.userName}, tu experiencia vale!</h4>
            <p style={{ marginBottom: 8 }}>
              Eres parte de la red de abogados que conecta con personas que realmente necesitan
              ayuda legal.
            </p>
            <p className='desc-p' style={{ marginBottom: 16, fontSize: 13, color: '#555' }}>
              Verifica tu perfil para que los clientes puedan encontrarte.
            </p>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: '12px',
            marginBottom: '20px',
          }}
        >
          <button
            className='btn-validate'
            style={{
              backgroundColor: '#FB8C00',
            }}
            onClick={() => this.props.goToValidation?.()}
          >
            1. Envíe sus documentos
            <img src={DocumentIcon} alt='Icono documento' />
          </button>
          <WhatsAppButton
            phoneNumber='584225342555'
            message='Hola, quiero agendar una cita para la verificación de mi cuenta en Legalmente.'
            buttonText='2. Agende cita para verificarlos'
            className='btn-whatsapp'
            style={{ backgroundColor: '#25D366' }}
          />
        </div>
      </div>
    );
  }
}

export default ModalWelcome;
